<template>
  <!-- Providers Section -->
  <section class="providers-section abt-provider">
    <div class="container">
      <div class="section-heading">
        <div class="row">
          <div class="col-md-6">
            <p class="mb-0 fs-16">Meet Our Experts</p>
            <h2 class="fs-32">Top Providers</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="providers-slider owl-carousel owl-theme">
          <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
            <Slide v-for="item in About_Provider" :key="item.id">
              <div class="item">
                <div class="card providerset p-0 flex-fill">
                  <div class="card-body">
                    <div class="providerset-img">
                      <router-link to="/service-provider/provider-details">
                        <img
                          :src="require(`@/assets/img/providers/${item.Image}`)"
                          alt="img"
                        />
                      </router-link>
                    </div>
                    <div class="providerset-content text-start">
                      <div class="providerset-price">
                        <div class="row justify-content-center align-items-center">
                          <div class="col-md-7">
                            <div class="providerset-name">
                              <h4 class="d-flex align-items-center">
                                <router-link
                                  to="/service-provider/provider-details"
                                  class="me-1 text-truncate"
                                  >{{ item.Name }}</router-link
                                ><i class="ti ti-circle-check-filled text-success"></i>
                              </h4>
                              <span>{{ item.Profession }}</span>
                            </div>
                          </div>
                          <div class="col-md-5">
                            <div class="providerset-prices">
                              <h6>{{ item.Price }}<span>/hr</span></h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="provider-rating">
                        <div class="rating fs-13">
                          <i class="ti ti-star-filled me-1 text-warning"></i>
                          <i class="ti ti-star-filled me-1 text-warning"></i>
                          <i class="ti ti-star-filled me-1 text-warning"></i>
                          <i class="ti ti-star-filled me-1 text-warning"></i>
                          <i class="ti ti-star-half-filled text-warning me-1"></i
                          ><span class="fs-13">(320)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Slide>
            <template #addons>
              <Pagination />
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </section>
  <!-- /Providers Section -->
</template>

<script>
import { Carousel, Pagination, Slide } from "vue3-carousel";
import About_Provider from "@/assets/json/about-provider.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      About_Provider: About_Provider,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
  },
};
</script>
